// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "Widgets" + "." + "8cb0c2c9" + ".chunk.css";
};